import { Container, Grid, Typography } from "@mui/material";
import contact from "../data/contact.json";
import ContactCard from "../components/ContactCard";
import { Email, LinkedIn, Phone } from "@mui/icons-material";

export default function Contact() {
  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>Get in Touch</Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, sm: 6 }}>
          <ContactCard
            label="Email"
            value={contact.email}
            href={`mailto:${contact.email}`}
            icon={<Email color="primary" />}
          // isCopyable
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <ContactCard
            label="Phone"
            value={contact.phone}
            href={`tel:${contact.phone}`}
            icon={<Phone color="primary" />}
          />
        </Grid>

        <Grid size={{ xs: 12, sm: 6 }}>
          <ContactCard
            label="LinkedIn"
            value={contact.linkedin}
            href={contact.linkedin}
            icon={<LinkedIn color="primary" />}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

